// extracted by mini-css-extract-plugin
export default {"sectionContainer":"income_sectionContainer__aW6LL","section1":"income_section1__L4dDU","gridCol2":"income_gridCol2__Xh3k1","paddinger":"income_paddinger__z3X0W"};